import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'pages',
    path: '/pages',
    component: () => LazyLoadView(import(/* webpackChunkName: "pages" */ '@/views/Page/Pages.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-create',
    path: '/pages/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "page-create" */ '@/views/Page/Create.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-dashboard',
    path: '/pages/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "page-dashboard" */ '@/views/Page/Dashboard.vue')),
    meta: {
      bodyAttrs: { theme: 'Page.item.template.theme' },
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-edit',
    path: '/pages/:id/edit/:step?',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "page-mutate" */ '@/views/Page/Mutate/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-posts',
    path: '/pages/:id/posts/:collection?',
    redirect: to => {
      return {
        name: 'page-edit',
        params: { id: to.params.id, step: `posts-${to.query.collection}` },
        query: { ...to.query, collection: undefined },
      }
    },
  },
  {
    name: 'page-leads',
    path: '/pages/:id/leads',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "page-leads" */ '@/views/Page/Leads/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-lead-create',
    path: '/pages/:reference/lead/create',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-create" */ '@/views/Lead/Create.vue')),
    beforeEnter: isAuthenticated,
    meta: {
      onModel: 'Page',
    },
  },
  {
    name: 'page-lead-edit',
    path: '/pages/:reference/lead/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-mutate" */ '@/views/Lead/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'page-analytics',
    path: '/pages/:id/analytics',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "page-analytics" */ '@/views/Page/Analytics.vue')),
    beforeEnter: isAuthenticated,
  },
]
